const normalize = (value: string): string => (value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

const fuzzyContains = (value: string, search: string): boolean => {
  let searchIndex = 0;

  for (let valueIndex = 0; valueIndex < value.length && searchIndex < search.length; valueIndex++) {
    if (value[valueIndex] === search[searchIndex]) {
      searchIndex++;
    }
  }

  return searchIndex === search.length;
};

const matches = (value: string, term: string): boolean => {
  const normalizedValue = normalize(value);
  return normalize(term)
    .split(/\s+/)
    .filter(Boolean)
    .every(token => fuzzyContains(normalizedValue, token));
};

export const initFuzzySelect = (context: JQuery | Document = document): void => {
  $('[data-fuzzy-select]', context).each(function () {
    const select = $(this);

    if (select.hasClass('select2-hidden-accessible')) {
      return;
    }

    select.select2({
      width: '100%',
      matcher: function (params, data) {
        const term = $.trim(params.term);

        if (!term) {
          return data;
        }

        if (data.children) {
          const match = $.extend(true, {}, data);
          match.children = match.children.filter(child => matches(`${data.text} ${child.text}`, term));
          return match.children.length ? match : null;
        }

        return matches(data.text, term) ? data : null;
      }
    });
  });
};

